import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/thumbs-up-filled.vue
var o = {
	name: "DtIconThumbsUpFilled",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--thumbs-up-filled"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Thumbs Up Filled",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M6.044 1a.406.406 0 0 0-.367.222L4.128 4.291v6.563c.075.09.187.146.313.146h4.147a1.335 1.335 0 0 0 1.28-.952l1.079-3.678a1.312 1.312 0 0 0-.213-1.163 1.33 1.33 0 0 0-1.066-.529H7.482l.341-1.395v-.001a1.827 1.827 0 0 0-.333-1.567A1.853 1.853 0 0 0 6.044 1ZM3.317 4.682v6.314A.412.412 0 0 1 3.26 11h-.927c-.353 0-.692-.14-.942-.387A1.316 1.316 0 0 1 1 9.678V6c0-.35.14-.687.39-.935s.589-.387.942-.387h.927c.02 0 .04.002.058.004Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=thumbs-up-filled.js.map